import { ArrowPathIcon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { sendNewEmailByPo } from "../../slices/mailSlice";
import { arrayHasItems } from "../../helpers/common";

const SendEmailButton = ({
  shipment,
  setSyncEmail,
  syncEmail,
  emailIsLoading,
  sendEmailCallback,
  label
}) => {
  return (
    <button
      onClick={async (e) => {
        e.stopPropagation();
        setSyncEmail((prev) => [...prev, `${shipment.id}-soon`]);
        try {
          await sendEmailCallback();
        } catch (error) {
          console.error('Email sending failed:', error);
        }
        setSyncEmail((prev) => prev.filter((item) => item !== `${shipment.id}-soon`));
      }}
      disabled={arrayHasItems(syncEmail)}
      className="w-full text-left flex flex-row gap-2 items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:bg-gray-200"
    >
      {label ? label: ""} {syncEmail.includes(`${shipment.id}-soon`) && emailIsLoading && (
        <ArrowPathIcon className="animate-spin -ml-0.5 mr-2 h-4 w-4" />
      )}
    </button>
  )
}

export const EmailsDropdownMenu = ({
    shipment,
    isOpen,
    onToggle,
    setSyncEmail,
    syncEmail,
    emailIsLoading,
    possibleToSendEmail7Days,
    possibleToSendEmailToday,
    possibleToSendOldEmail
}) => {
    const dropdownRef = useRef();
    const dispatch = useDispatch();
    return (
      <div className="relative inline-block text-left dropdown-action" ref={dropdownRef}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          className="p-2 hover:bg-gray-100 rounded"
        >
          <EllipsisVerticalIcon className="h-6 w-6 text-primary hover:text-gray-900" />
        </button>
  
        {isOpen && (
          <div className="absolute right-0 z-10 mt-1 mr-3 w-[220px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
            <div>
              {possibleToSendEmail7Days && (
                <SendEmailButton
                  shipment={shipment}
                  setSyncEmail={setSyncEmail}
                  syncEmail={syncEmail}
                  emailIsLoading={emailIsLoading}
                  sendEmailCallback={async () => {
                    await dispatch(sendNewEmailByPo({ id: shipment.id, type: "soon" })).unwrap();
                  }}
                  label="Send reminder (7 days)"
                />
              )}
              {possibleToSendEmailToday && (
                <SendEmailButton
                  shipment={shipment}
                  setSyncEmail={setSyncEmail}
                  syncEmail={syncEmail}
                  emailIsLoading={emailIsLoading}
                  sendEmailCallback={async () => {
                    await dispatch(sendNewEmailByPo({ id: shipment.id, type: "today" })).unwrap();
                  }}
                  label="Send reminder (0 days)"
                />
              )}
              {possibleToSendOldEmail && (!possibleToSendEmail7Days && !possibleToSendEmailToday) && (
                <SendEmailButton
                  shipment={shipment}
                  setSyncEmail={setSyncEmail}
                  syncEmail={syncEmail}
                  emailIsLoading={emailIsLoading}
                  sendEmailCallback={async () => {
                    await dispatch(sendNewEmailByPo({ id: shipment.id, type: "old" })).unwrap();
                  }}
                  label="Send old reminder"
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
};
  